import React, { useEffect, useState } from "react";
import styles from "./CareerBackground.module.css";
import { Footer, Header, useConfirm } from "@components";
import { useNavigate } from "react-router-dom";
import { encoded } from "@/utils";
import { useCheckLogin, useLoadReset } from "@/hooks";
import Axios from "@/Axios";

export default function CareerBackground() {
  const loadReset = useLoadReset();
  const confirm = useConfirm();
  const defaultState = {
    images: [],
    isLogin: false,
  };
  const [state, setState] = useState(defaultState);
  const resetState = () => {
    setState(defaultState);
    loadReset();
  };
  const checkLogin = useCheckLogin();
  const navigate = useNavigate();

  const toUpdate = () => {
    const images = encoded(state.images, true);
    navigate(`/career-background-update/${images}`);
  };
  const find = () => {
    Axios.get("/api/career-background", { params: {} }).then((res) => {
      if (res.data?.errMsg) {
        confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        return;
      }
      const careerBackground = res.data?.careerBackground;
      if (!careerBackground?.images) {
        setState((s) => ({ ...s, images: [] }));
        return;
      }
      setState((s) => ({ ...s, images: careerBackground.images }));
    });
  };

  useEffect(() => {
    find();
    const callbackId = checkLogin(
      () => {
        setState((s) => ({ ...s, isLogin: true }));
      },
      () => {
        setState((s) => ({ ...s, isLogin: false }));
      }
    );
    return () => {
      cancelIdleCallback(callbackId);
      resetState();
    };
  }, []);
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <Header title="이력" forceLink="/" />
        <div className={styles.adBanner}>
          <div className={styles.adArea}>
            <div className={styles.titleArea1}>
              <div className={styles.adTitle}>
                <span className={styles.adChildDevelopment}>About</span>
              </div>
              <div className={styles.buttonArea}>
                <div className={styles.description}>
                  <span className={styles.sponsoredAd}>@good_miyorning</span>
                </div>
                {state.isLogin && (
                  <button className={styles.adButton} onClick={toUpdate}>
                    <span className={styles.learnMore}>수정</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.pdfContainer}>
          <div className={styles.pdfContentArea}>
            {state.images?.length > 0 ? (
              state.images.map((img, idx) => (
                <img key={idx} className={styles.png} src={img} alt="..." />
              ))
            ) : (
              <p className={styles.notFound}>이력 정보가 존재하지 않습니다</p>
            )}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
